var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import parse from "date-fns/parse";
import format from "date-fns/format";
import { Classes, InputGroup } from "@blueprintjs/core";
import { DateInput } from "@blueprintjs/datetime";
import { LangContext } from "../../LangContext";

DateField.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Field value
   */
  value: PropTypes.instanceOf(Date),

  /**
   * Minimum date available in popup.
   */
  minDate: PropTypes.instanceOf(Date),

  /**
   * Maximum date available in popup.
   */
  maxDate: PropTypes.instanceOf(Date),

  /**
   * Triggered when field value is changed
   */
  onValueChange: PropTypes.func,

  /**
   * Triggered when field validity is changed
   */
  onValidityChange: PropTypes.func,

  /**
   * Set as required. If field is set as required an value is NULL then field will be marked as invalid
   */
  required: PropTypes.bool,

  /**
   * Set to true to disable this field
   */
  disabled: PropTypes.bool
} : {};

DateField.defaultProps = {
  minDate: new Date(1970, 0, 1, 0, 0, 0, 0),
  maxDate: new Date(2050, 11, 31, 23, 59, 59, 999)
};

function DateField(props) {
  var lang = useContext(LangContext);

  var value = props.value,
      onValueChange = props.onValueChange,
      onValidityChange = props.onValidityChange,
      required = props.required,
      disabled = props.disabled,
      readOnly = props.readOnly,
      displayForm = props.displayForm,
      minDate = props.minDate,
      maxDate = props.maxDate;

  var _useState = useState(true),
      valid = _useState[0],
      setValid = _useState[1];

  var jsDateFormatter = {
    // note that the native implementation of Date functions differs between browsers
    formatDate: function formatDate(date) {
      return date ? format(date, lang.dateFormat) : "";
    },
    parseDate: function parseDate(str) {
      return parse(str, lang.dateFormat, new Date());
    },
    placeholder: lang.dateFormatPlaceholder
  };

  var isFloat = function isFloat(value) {
    return isNaN(value) ? false : true;
  };

  useEffect(function () {
    var invalidValue = !!value && !isFloat(value);
    var invalidRequired = !value && required;
    var isValid = !(invalidValue || invalidRequired);

    if (isValid != valid) {
      setValid(isValid);
      onValidityChange && onValidityChange(isValid);
    }
  }, [value, valid, required]);

  var handleChange = function handleChange(value) {
    onValueChange(value);
  };

  return displayForm ? React.createElement(
    "span",
    { className: "dt-field-value" },
    jsDateFormatter.formatDate(value)
  ) : readOnly ? React.createElement(InputGroup, {
    readOnly: true,
    value: value ? jsDateFormatter.formatDate(value) : ""
  }) : React.createElement(DateInput, _extends({
    className: Classes.FILL
  }, jsDateFormatter, {
    onChange: handleChange,
    value: value,
    showActionsBar: true,
    disabled: disabled,
    minDate: minDate,
    maxDate: maxDate,
    fill: true,
    clearButtonText: lang.clear,
    todayButtonText: lang.today,
    dayPickerProps: {
      months: lang.months,
      weekdaysShort: lang.weekdaysShort,
      weekdaysLong: lang.weekdaysLong
    }
  }));
}

export default DateField;